// Copyright (c) 2024 Comsearch, Inc., All rights reserved

// so we have a simple, consistent way to get a label for a meters/feet value.

const getUnitLabelForKmAndMiles = unitType => (
  unitType === 'SI'
    ? 'km'
    : 'mi'
)

export default getUnitLabelForKmAndMiles
